
import { Input } from '@mui/material';
import EDButton from '../Buttons/Button/EDButton';
import EDBox from '../EDBox/EDBox';
import EDIcon from '../Icon/EDIcon';

interface IProps {
  setFiles: (files: FileList | null) => void;
  hideButtonIcon?: boolean;
}

const SelectFileButton: React.FC<React.PropsWithChildren<IProps>> = props => {
  return (
    <EDBox
      sx={{
        display: 'inline-flex',
        height: theme => theme.spacing(5),
        alignItems: 'center',
      }}
    >
      <Input
        sx={{ display: 'none' }}
        id="contained-button-file"
        type="file"
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          const files = event.target.files;
          props.setFiles(files);
        }}
        inputProps={{ multiple: true }}
      />
      <EDBox>
        <label htmlFor="contained-button-file">
          <EDButton
            icon={
              props.hideButtonIcon ? undefined : (
                <EDIcon marginRight={1} iconType="add" color="primary" />
              )
            }
            label="Välj fil"
            component="span"
            flat
            primary
          />
        </label>
      </EDBox>
    </EDBox>
  );
};

export default SelectFileButton;
